import {BaseContainerModel} from "../../base-container.model";
import {bl_wf_project_issue_type_RowClass} from "../../../dbschema/bl_wf_project_issue_type_link.model";

export class WfProjectIssueTypeContainerModel extends BaseContainerModel {
  bl_wf_project_issue_type_link: bl_wf_project_issue_type_RowClass = new bl_wf_project_issue_type_RowClass();
}
